import React, { useEffect } from 'react';
import '../styles/InfoLicencia.css';
import { useAuth } from "../context/AuthContext.jsx";
import FileManager from "../componentes/FileManager";

const InfoLicencia = () => {
  const { isAdmin } = useAuth();

  useEffect(() => {
    // Al cargar, lleva la vista al inicio del componente
    const elemento = document.getElementById("info-licencia");
    if (elemento) {
      elemento.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  const linkWhatsapp = "https://wa.me/5493497412598?text=Hola,%20quisiera%20solicitar%20un%20turno%20para%20la%20licencia.";

  return (
      <div id="info-licencia" className="licencia-container">
        <div className="licencia-card">

          {/* ENCABEZADO CENTRADO */}
          <header className="licencia-header">
            
            <h2 className="licencia-title">Licencia Nacional de Conducir</h2>
            <p className="licencia-intro">
              Este trámite brinda información sobre los procedimientos para obtener la Licencia Nacional de Conducir.
              Se deben cumplimentar diferentes etapas obligatorias de formación y evaluación.
            </p>

            <div className="licencia-cta">
              <p style={{marginBottom: '10px', fontWeight: 'bold'}}>Solicitá tu turno en CEL PROGRESO:</p>
              <a href={linkWhatsapp} target="_blank" rel="noopener noreferrer" className="licencia-whatsapp-btn">
                <span>💬</span> Enviar mensaje al 3497-412598
              </a>
            </div>
          </header>

          {/* ✅ GESTIÓN DE ARCHIVOS (Solo Admin) */}
          {isAdmin && (
              <div className="admin-zone-licencia">
                <FileManager
                    tableName="licencia_files"
                    folderName="licencia_conducir"
                    isAdmin={isAdmin}
                />
              </div>
          )}

          <hr className="licencia-divider" />

          {/* REQUISITOS Y EDADES (Contenido Recuperado) */}
          <section className="licencia-section">
            <h3 className="licencia-subtitle">📋 ¿Qué necesito?</h3>
            <p>Cumplir con los requerimientos de la Ley Provincial Nº 13.133 y Ley Nacional Nº 24.449.</p>

            <div className="licencia-info-box">
              <h4>1. Edades mínimas requeridas:</h4>
              <ul className="licencia-list">
                <li><strong>Clases A21, B1, B2, G1, G2 y F:</strong> Mayor de 18 años.</li>
                <li><strong>Clase A22:</strong> Mayor de 21 años (o menor si acredita 2 años en clase A21).</li>
                <li><strong>Clase A3:</strong> Mayor de 21 años.</li>
                <li><strong>Clases C, E1 y E2:</strong> Mayor de 21 años y 1 año de antigüedad en clase inferior.</li>
                <li><strong>Clases D1, D2 y D3:</strong> Mayor de 21 años y 1 año de antigüedad en clase inferior.</li>
              </ul>
            </div>
          </section>

          {/* PROCEDIMIENTO PASO A PASO */}
          <section className="licencia-section">
            <h3 className="licencia-subtitle">🔄 Procedimiento</h3>
            <ol className="licencia-ordered-list">
              <li>Imprimir y presentar la boleta pagada del <strong>CENAT</strong>.</li>
              <li>Completar el Formulario de Solicitud y la DDJJ de Padecimientos ante el administrativo.</li>
              <li>Clases D: Presentar Certificado de Antecedentes Penales.</li>
              <li>Presentar DNI original con domicilio actualizado.</li>
              <li>Presentar Licencia anterior (si posee).</li>
              <li>Realizar el curso de formación vial.</li>
              <li>Aprobar examen psicofísico.</li>
              <li>Aprobar examen teórico informatizado.</li>
              <li>Aprobar examen práctico de idoneidad conductiva.</li>
            </ol>
          </section>

          {/* COSTOS Y LUGAR */}
          <div className="licencia-row">
            <div className="licencia-col">
              <h3 className="licencia-subtitle">💰 ¿Cuánto cuesta?</h3>
              <p>El valor es determinado por cada Centro (Tasa Municipal) + el costo del CENAT (Nacional).</p>
            </div>
            <div className="licencia-col">
              <h3 className="licencia-subtitle">📍 ¿Dónde se realiza?</h3>
              <p>En el Centro de Habilitación correspondiente a tu domicilio real.</p>
              { /*<div className="nota-importante">
                <strong>📌 Nota Importante:</strong><br/>
                El Centro Emisor más cercano es <strong>PROGRESO</strong>. El número de WhatsApp indicado arriba corresponde a dicho centro.
              </div> */}
            </div>
          </div>

          {/* DESCARGAS Y MATERIAL (Dinámico + Estático) */}
          <section className="licencia-download-section">
            <h3 className="licencia-subtitle-white">📂 Material de Estudio y Descargas</h3>
            <p style={{color: 'white', marginBottom: '20px'}}>Accedé a la documentación local y manuales provinciales:</p>

            {/* Aquí el FileManager muestra la lista de archivos de la DB */}
            <FileManager
                tableName="licencia_files"
                folderName="licencia_conducir"
                isAdmin={false} // Pasamos false para que solo muestre la lista sin el botón de subir aquí
            />

            <div className="licencia-btn-grid" style={{marginTop: '20px'}}>
              <a href="https://www.santafe.gob.ar/index.php/content/download/156890/764871/file/Folleto" target="_blank" rel="noopener noreferrer" className="licencia-download-btn">📘 Folleto Señalización I</a>
              <a href="https://www.santafe.gob.ar/index.php/content/download/156889/764868/file/Folleto" target="_blank" rel="noopener noreferrer" className="licencia-download-btn">📘 Folleto Señalización II</a>
              <a href="https://www.santafe.gov.ar/index.php/web/content/download/156883/764852/file/Material%20de%20Estudio.pdf" target="_blank" rel="noopener noreferrer" className="licencia-download-btn">📚 Material de Estudio (PDF)</a>
              <a href="https://www.santafe.gob.ar/examenlicencia/examenETLC/listarCuestionarios.php" target="_blank" rel="noopener noreferrer" className="licencia-download-btn" style={{backgroundColor: '#4CAF50'}}>💻 Simulador de Examen</a>
            </div>
          </section>

          {/* NORMATIVAS */}
          <section className="licencia-section">
            <h3 className="licencia-subtitle">⚖️ Normativas Relacionadas</h3>
            <ul className="licencia-list-small">
              <li><a href="https://www.santafe.gov.ar/index.php/content/view/full/152857/" target="_blank" rel="noreferrer">Ley Provincial 13169 - Código de Faltas</a></li>
              <li><a href="https://www.santafe.gov.ar/index.php/content/view/full/152859/" target="_blank" rel="noreferrer">Ley Nacional 24449 - Ley de Tránsito</a></li>
              <li><a href="https://www.santafe.gov.ar/index.php/content/view/full/152844/" target="_blank" rel="noreferrer">Ley Provincial 13133 - Adhesión Nacional</a></li>
            </ul>
          </section>
        </div>
      </div>
  );
};

export default InfoLicencia;